import { useQuery } from "react-query";
import { apiListContractEmployeeValuationHistory } from "../../../../../api/contract/apiListContractEmployeeValuationHistory";
import {
  ExtractFnReturnType,
  QueryConfig,
} from "../../../../../lib/react-query";
import { contractKeys } from "../util/contract.query-keys";

export const getContractEmployeeValuationHistory = async ({
  contractId,
}: {
  contractId: string;
}) => {
  const response = await apiListContractEmployeeValuationHistory(contractId);

  return response.items;
};

type QueryFnType = typeof getContractEmployeeValuationHistory;

type UseContractEmployeeValuationHistoryOptions = {
  contractId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useContractEmployeeValuationHistory = ({
  contractId,
  config,
}: UseContractEmployeeValuationHistoryOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: contractKeys.employeeValuationHistory(contractId),
    queryFn: () => getContractEmployeeValuationHistory({ contractId }),
  });
};
